export const UserTypes = {
    CLIENT: "CLIENT",
    RCIC: "RCIC",
    ADMIN: "ADMIN"
} as const;